import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Col, Container, Row, Button, Form as RBForm, Spinner } from "react-bootstrap";
import * as Yup from "yup";
import { useParams, useNavigate } from "react-router-dom";

import SingleDetailHeader from "../../components/singleDetail/SingleDetailHeader";
import Notification, { showToast } from "../../../components/common/notification/Notification";
import Api from "../../components/api/Api";
import UserProfile from "../userProfile/UserProfile";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";

// ✅ Validation Schema
const passwordSchema = Yup.object({
  newPassword: Yup.string()
    .required("New Password is required")
    .min(6, "Password must be at least 6 characters"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const MainPassowd = () => {
  const breadcrumbItems = [
    { label: "", link: "/admin", icon: "fa-solid fa-house" },
    { label: "User", link: "/user" },
    { label: "Change Password", link: "", active: true },
  ];

  return (
    <Container fluid className="container-padding" style={{ marginTop: "2rem", padding: "0rem 4rem" }}>
      <Notification />
      <Row>
        <BreadCrumb items={breadcrumbItems} />
        <Col md={3}>
          <UserProfile />
        </Col>
        <Col md={9}>
          <SingleDetailHeader
            header="Change Password"
            description="Update your password below"
          />
          <ChangePassword />
        </Col>
      </Row>
    </Container>
  );
};

const ChangePassword = () => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const changePassword = Api({ url: "admin/changePassword" });

  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
        userId: +userId,
        password: values.confirmPassword,
      };

      const responseData = await changePassword.editData(
        payload,
        "multipart/form-data"
      );

      if (responseData.data.statusType === "SUCCESS") {
        showToast("Password changed successfully!", { type: "success" });
        resetForm();
        setTimeout(() => navigate("/user/profile"), 2000);
      } else {
        showToast("Failed to update password", { type: "error" });
      }
    } catch (error) {
      console.error("Error:", error);
      showToast("Something went wrong", { type: "error" });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Formik
      initialValues={{ newPassword: "", confirmPassword: "" }}
      validationSchema={passwordSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting }) => (
        <Form>
          <Row>
            <Col md={6}>
              <RBForm.Group className="mb-3">
                <RBForm.Label>New Password</RBForm.Label>
                <Field
                  type={showPassword ? "text" : "password"}
                  name="newPassword"
                  className="form-control"
                  placeholder="Enter new password"
                />
                <ErrorMessage
                  name="newPassword"
                  component="div"
                  className="text-danger small"
                />
              </RBForm.Group>
            </Col>
            <Col md={6}>
              <RBForm.Group className="mb-3">
                <RBForm.Label>Confirm Password</RBForm.Label>
                <Field
                  type={showPassword ? "text" : "password"}
                  name="confirmPassword"
                  className="form-control"
                  placeholder="Confirm new password"
                />
                <ErrorMessage
                  name="confirmPassword"
                  component="div"
                  className="text-danger small"
                />
              </RBForm.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-between align-items-center">
            <RBForm.Check
              type="checkbox"
              label="Show Password"
              onChange={() => setShowPassword((prev) => !prev)}
            />

            <Button type="submit" variant="primary" disabled={isSubmitting}>
              {isSubmitting ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Changing...
                </>
              ) : (
                "Change Password"
              )}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export { MainPassowd, ChangePassword }; 
